module.exports = __webpack_public_path__ + "img/img08.c8371ab8.png";